(function () {
  // Exige usuario@dominio.tld — al menos un carácter antes de la @, al
  // menos un carácter entre la @ y el punto, y al menos un carácter
  // después del punto (el dominio final: .com, .es, .de, etc.). Antes
  // solo se comprobaba que el campo no estuviera vacío, así que
  // "juan@gmail" (sin dominio) pasaba la validación sin problema.
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Solo dígitos, con un '+' opcional únicamente al inicio (para el
  // indicativo de país) — nada de letras, espacios, guiones ni
  // paréntesis. El teléfono sigue siendo opcional: si el campo está
  // vacío, no bloquea el envío; si tiene contenido, debe cumplir este
  // formato.
  var PHONE_PATTERN = /^\+?[0-9]+$/;

  // IMPORTANTE: estas declaraciones deben ir ANTES de la línea de abajo
  // — initContactPicker ahora llama a validate() de inmediato al
  // inicializar, y validate() usa estos patrones. Si quedaran después,
  // se ejecutarían "undefined" en ese primer llamado (error real que
  // se detectó y corrigió durante las pruebas).
  document.querySelectorAll('[data-contact-forms-lola-picker]').forEach(function (picker) {
    initContactPicker(picker);
  });

  function initContactPicker(picker) {
    var form = picker.closest('form');
    var select = picker.querySelector('[data-contact-forms-lola-subject-select]');
    var result = picker.querySelector('[data-contact-forms-lola-result]');
    var desc = picker.querySelector('[data-contact-forms-lola-desc]');
    var subjectHidden = picker.querySelector('[data-contact-forms-lola-subject-hidden]');
    var targetEmailHidden = picker.querySelector('[data-contact-forms-lola-target-email-hidden]');
    var companyField = picker.querySelector('[data-contact-forms-lola-company-field]');
    var companyInput = companyField ? companyField.querySelector('[data-contact-forms-lola-required-b2b]') : null;
    var submitBtn = picker.querySelector('[data-contact-forms-lola-submit]');
    var emailField = picker.querySelector('input[type="email"]');
    var phoneField = picker.querySelector('input[type="tel"]');
    var honeypot = form ? form.querySelector('[data-contact-forms-lola-honeypot]') : null;
    var loadedAtField = form ? form.querySelector('[data-contact-forms-lola-loaded-at]') : null;

    // Marca la hora exacta en que el formulario quedó listo para
    // usarse — es la referencia contra la que se mide, al enviar, si
    // pasó suficiente tiempo como para que lo haya llenado una persona
    // real (ver el listener de "submit" más abajo).
    if (loadedAtField) {
      loadedAtField.value = String(Date.now());
    }

    if (!select || !result || !desc) return;

    var alwaysRequiredFields = Array.prototype.slice.call(
      picker.querySelectorAll('[data-contact-forms-lola-required]')
    );

    // Ubica el asterisco asociado a un campo vía label[for="id-del-campo"]
    // — la misma asociación estándar de accesibilidad que ya conecta
    // cada label con su input, así que no depende de la posición exacta
    // en el DOM ni de estructuras anidadas distintas (el select de
    // asunto vive en un contenedor diferente al resto de los campos).
    function getAsterisk(field) {
      if (!field || !field.id) return null;
      var label = picker.querySelector('label[for="' + field.id + '"]');
      return label ? label.querySelector('[data-contact-forms-lola-asterisk]') : null;
    }

    function setAsteriskValid(field, isValid) {
      var asterisk = getAsterisk(field);
      if (asterisk) asterisk.classList.toggle('is-valid', isValid);
    }

    function validate() {
      if (!submitBtn) return;

      var allFilled = alwaysRequiredFields.every(function (field) {
        var fieldOk = field.value.trim() !== '';
        // El email, además de no estar vacío, debe cumplir el patrón
        // completo — se marca inválido (asterisco naranja) si falta el
        // dominio, aunque el campo no esté vacío.
        if (field === emailField) {
          fieldOk = fieldOk && EMAIL_PATTERN.test(field.value.trim());
        }
        setAsteriskValid(field, fieldOk);
        return fieldOk;
      });

      setAsteriskValid(select, select.value !== '');
      if (select.value === '') allFilled = false;

      // El campo de empresa/marca es visible en B2B, pero ya no es
      // obligatorio — no se suma a la validación que habilita el botón.

      var emailOk = !emailField || EMAIL_PATTERN.test(emailField.value.trim());

      // El teléfono es opcional: vacío está bien. Si tiene contenido,
      // debe cumplir el patrón (solo dígitos + '+' inicial opcional).
      var phoneValue = phoneField ? phoneField.value.trim() : '';
      var phoneOk = !phoneField || phoneValue === '' || PHONE_PATTERN.test(phoneValue);

      submitBtn.disabled = !(allFilled && emailOk && phoneOk);
    }

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var email = option.getAttribute('data-email');

      if (!email) {
        result.hidden = true;
        return;
      }

      desc.textContent = option.getAttribute('data-description') || '';
      if (subjectHidden) subjectHidden.value = option.textContent.trim();
      if (targetEmailHidden) targetEmailHidden.value = email;

      var isB2B = option.getAttribute('data-form-variant') === 'b2b';
      if (companyField) {
        companyField.hidden = !isB2B;
      }
      if (companyInput && !isB2B) {
        // Se limpia el valor al salir de B2B — pero ya no se marca
        // como "required" al entrar, el campo es siempre opcional.
        companyInput.value = '';
      }

      result.hidden = false;
      validate();
    });

    alwaysRequiredFields.forEach(function (field) {
      field.addEventListener('input', validate);
    });
    if (companyInput) {
      companyInput.addEventListener('input', validate);
    }

    // El campo de email ya está incluido en alwaysRequiredFields (tiene
    // data-contact-forms-lola-required), así que su evento 'input' ya
    // dispara validate() arriba — no hace falta un listener aparte.

    if (phoneField) {
      // Saneamiento en vivo: descarta cualquier tecla que no sea un
      // dígito o un '+' inicial, en vez de solo bloquear el envío al
      // final. Reconstruye el valor limpio en cada pulsación.
      phoneField.addEventListener('input', function () {
        var raw = phoneField.value;
        var hasLeadingPlus = raw.charAt(0) === '+';
        var digitsOnly = raw.replace(/[^0-9]/g, '');
        phoneField.value = (hasLeadingPlus ? '+' : '') + digitsOnly;
        validate();
      });
    }

    // Verificación anti-bot real, al momento del envío — reemplaza al
    // checkbox de "no soy un bot" (que no verificaba nada por sí
    // mismo). Dos señales combinadas, ambas invisibles/sin fricción
    // para una persona real:
    //   1. Honeypot con contenido → lo llenó algo automatizado, ningún
    //      humano ve ese campo.
    //   2. Envío a los pocos segundos de cargar la página → nadie lee
    //      y completa un formulario tan rápido.
    // Si alguna dispara, se bloquea el envío en silencio (sin mensaje
    // de error ni pista de por qué falló), dejando el resto del
    // formulario intacto tal como estaba.
    var MIN_SUBMIT_TIME_MS = 3000;

    if (form) {
      form.addEventListener('submit', function (event) {
        if (honeypot && honeypot.value.trim() !== '') {
          event.preventDefault();
          return;
        }

        if (loadedAtField) {
          var loadedAt = parseInt(loadedAtField.value, 10);
          if (!isNaN(loadedAt) && Date.now() - loadedAt < MIN_SUBMIT_TIME_MS) {
            event.preventDefault();
          }
        }
      });
    }

    validate();
  }
})();